export const MAX_PRIORITY = 99999999999
export const MAX_ACKNOWLEDGE_TIME = 99999999999
export const MAX_RANK = 99999999999
